import React, {useEffect,useRef, useState} from "react";
import {  useParams } from "react-router-dom";
import { withStyles } from '@material-ui/core/styles';
import { makeStyles } from '@material-ui/core/styles';
import '@fontsource/roboto';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';



const useStyles = makeStyles((theme )=> ({
  img:{
    maxWidth: '80%'
  },
  li:{
    paddingBottom: '10px'
  }
}));

export default function PreSurvey(props){
  let {postno, condition } = useParams();
  postno=parseInt(postno);
  const classes=useStyles();
  
  return(
    <div>
      <Typography variant='body1' className={classes.li}>
        Please answer the following survey questionnaire. Note that this survey is long and will take 15-25 minutes. The completion code will be provided at the end of the survey.
      </Typography>
      <Typography variant='body1' className={classes.li}>
        As in the pre-survey, there exist attention check question. Note that your response can be rejected if you fail to pass the attention check question. Thank you for your cooperation! 
      </Typography>
      <Typography variant='body1' className={classes.li}>
        For the 'GROUP' question on the second page of the survey, please select {condition==='binary'? <span style={{color: 'red'}}> Apple </span> : <span style={{color: 'red'}}> Banana </span>}.
      </Typography>
       <iframe id='post-reading-survey' title='pre-reading-survey'src="https://mit.co1.qualtrics.com/jfe/form/SV_es5TNsKiE0okjsy" style={{width:"1000px", height:"673px", frameBorder:"0", marginHeight:"0", marginWidth:"0"}} >Loading…</iframe>
      </div>
  )
}
